export const CHANGE_LOCATION = "CHANGE_LOCATION";
export const SET_LOCATION = "SET_LOCATION";
export const FETCH_STATE_REQUEST = "FETCH_STATE_REQUEST";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_ALL_STATE_SUCCESS = "FETCH_ALL_STATE_SUCCESS";
export const FETCH_STATE_FAILURE = "FETCH_STATE_FAILURE";
